var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import CardSection from './CardSection';
import CardToolbar from './CardToolbar';
import CardToolbarLink from './CardToolbarLink';
import CardPropTypes from './CardPropTypes';

var UNIQUE_ID = 0;

var CardDrawers = function (_React$Component) {
  _inherits(CardDrawers, _React$Component);

  function CardDrawers(props) {
    _classCallCheck(this, CardDrawers);

    var _this = _possibleConstructorReturn(this, (CardDrawers.__proto__ || Object.getPrototypeOf(CardDrawers)).call(this, props));

    _this._cardId = UNIQUE_ID++;

    _this.state = {
      active: null
    };
    return _this;
  }

  _createClass(CardDrawers, [{
    key: 'handleLinkClick',
    value: function handleLinkClick(id) {
      this.props.onClick && this.props.onClick(id);

      this.setState(function (state) {
        return {
          active: state.active === id ? null : id
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var active = this.props.hasOwnProperty('active') ? this.props.active : this.state.active;

      var links = [];
      var drawers = [];

      this.props.drawers.forEach(function (drawer) {
        var isActive = drawer.id === active;
        var id = 'card-' + _this2._cardId + '-drawer-' + drawer.id;

        links.push(React.createElement(
          CardToolbarLink,
          {
            key: drawer.id,
            id: id,
            isActive: isActive,
            onClick: function onClick() {
              return _this2.handleLinkClick(drawer.id);
            }
          },
          drawer.name
        ));

        var className = 'cf-card__drawer';

        if (isActive) {
          className += ' cf-card__drawer--active';
        }

        drawers.push(React.createElement(
          'div',
          {
            key: drawer.id,
            role: 'tabpanel',
            'aria-labelledby': id,
            'aria-hidden': isActive ? 'false' : 'true',
            className: className
          },
          isActive && drawer.content
        ));
      });

      var containerClassName = 'cf-card__drawers_container';

      if (active) {
        containerClassName += ' cf-card__drawers_container--open';
      }

      return React.createElement(
        CardSection,
        null,
        React.createElement(CardToolbar, { controls: this.props.controls, links: links }),
        React.createElement(
          'div',
          { className: containerClassName },
          drawers
        )
      );
    }
  }]);

  return CardDrawers;
}(React.Component);

CardDrawers.propTypes = {
  onClick: PropTypes.func,

  active: PropTypes.string,
  drawers: CardPropTypes.cardDrawers.isRequired,

  // for an optional control to put on the left side of the toolbar
  controls: PropTypes.any
};

export default CardDrawers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-card/es/CardDrawers.js
// module id = 573
// module chunks = 0